export default __webpack_public_path__ + "static/media/undraw_medical_care_movn.409de930.svg";